import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BaseService } from './base.service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { GathercoCreditTransaction, GatherCreditCompany, PaginationModel, RequestParamModel } from '@coreModels';
import { throwError } from 'rxjs';
import { ApiConstants } from '@coreConstant';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GatherCommitmentService {

  constructor(public baseService: BaseService, private http: HttpClient) { }

  getCredit(requestParamModel: RequestParamModel, id: any): Observable<GatherCreditCompany | null> {
    return this.baseService.get(ApiConstants.GATHERCO_CREDIT_DETAIL_URL + id, requestParamModel)
      .pipe(
        map((response: any) => {
          // Assuming response.body.data is of type GatherCreditCompany
          const data = response.body.data as GatherCreditCompany;
          return data;
        }),
        catchError(err => {
          return of(null); // Return a safe observable
        })
      );
  }


  donateCredit(data: any): Observable<any | null> {
    return this.baseService.post(ApiConstants.GATHERCO_CREDIT_DONATE_URL, data).pipe(
      map(response => {
        return response; // Assuming response.body is of type CreditDonateResponse
      }),
      catchError(err => {
        return throwError(() => err); // Propagate the error if you want to handle it outside
      })
    );
  }

  indexGetCredit(requestParamModel: RequestParamModel): Observable<PaginationModel<GatherCreditCompany> | null> {
    return this.baseService.get(ApiConstants.GATHERCO_CREDIT_LIST_URL, requestParamModel)
      .pipe(
        map((response: any) => {
          const productList = new PaginationModel<GatherCreditCompany>();
          const headers = response.headers;
          productList.setHeaders(headers);
          productList.data = response.body.data as GatherCreditCompany[];
          return productList; // Assuming you want to return the PaginationModel
        }),
        catchError(err => {
          return of(null); // Return null in case of error
        })
      );
  }

  getCounter(requestParamModel: RequestParamModel) {
    return this.http.get(ApiConstants.GATHERCO_CREDIT_TRANSACTION_COUNTER_URL + requestParamModel?.getParams())
      .pipe(map((response: any) => {
        return response.data
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }

  getGatherCoCreditTransactions(requestParamModel: RequestParamModel) {
    return this.http.get(ApiConstants.GATHERCO_CREDIT_TRANSACTION_LIST_URL + requestParamModel?.getParams(), { observe: 'response' })
      .pipe(map<any, any>(response => {
        const accountList = new PaginationModel<GathercoCreditTransaction>();
        const headers = response.headers;
        accountList.setHeaders(headers);
        accountList.data = response.body.data as GathercoCreditTransaction[];
        return accountList;
      }), catchError((err: any) => {
        return throwError(() => err);
      }));
  }
}
